import { defaultTelosProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/telos/default-constants';

export const ZAPPY_CONTRACT_ADDRESS = '0xb9239af0697c8efb42cba3568424b06753c6da71';

export const ZAPPY_PROVIDER_CONFIGURATION = defaultTelosProviderConfiguration;
